export const REGISTRATION_DATA_STAGES = {
  LIST: 'initial',
  ADD: 'add',
  UPDATE: 'update',
  CONFIRMATION: 'confirmation',
  DELETE: 'delete',
  SELECT_DEFAULT: 'select_default',
  SUCCESS: 'success',
  CONTACT_CONFIRMATION: 'contact_confirmation',
}
